import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparisonRows } from '../data/comparison';
import { Eyebrow } from './Eyebrow';
export function Comparison() {
  return <section aria-labelledby="comparison-heading" className="bg-paper py-16 sm:py-24" data-id="element-47" data-mp="1l7e051w4x7h5">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-48" data-mp="1l5kxdxon77ef">
        <div className="max-w-2xl" data-id="element-49" data-mp="1pyw3txpjlm5t">
          <Eyebrow data-id="element-50" data-mp="1pzyvw8ylpunb">Before vs. after</Eyebrow>
          <h2 id="comparison-heading" className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-5xl" data-id="element-51" data-mp="1uw5q54hmxhpf">
            Stop improvising. Start teaching with a system.
          </h2>
        </div>

        <div className="mt-8 sm:mt-12" data-id="element-52" data-mp="23w2knmqphase">
          <div className="hidden grid-cols-2 gap-4 pb-4 sm:grid" data-id="element-53" data-mp="28x8ghtfnxe65">
            <p className="text-[11px] font-semibold uppercase tracking-label text-ink-muted" data-id="element-54" data-mp="9jvxrqog95k9">
              Without the Arsenal
            </p>
            <p className="text-[11px] font-semibold uppercase tracking-label text-brass-dark" data-id="element-55" data-mp="ek0i5rshakfr">
              With the Arsenal
            </p>
          </div>

          <ul className="divide-y divide-paper-300 border-t border-paper-300" data-id="element-56" data-mp="1ha0m704xeqhz">
            {comparisonRows.map(row => <li key={row.without} className="grid gap-3 py-5 sm:grid-cols-2 sm:gap-4" data-id="element-57" data-mp="1d7m3cg19bqqp">
                <p className="flex items-start gap-3 text-sm leading-relaxed text-ink-muted sm:text-base" data-id="element-58" data-mp="189u9vhkyrwke">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-wine" aria-hidden="true" data-id="element-59" data-mp="24zuwb9xv20yj" />
                  <span data-id="element-60" data-mp="20xgg6xlktfay">
                    <span className="mr-1 font-semibold uppercase tracking-wide text-wine sm:hidden" data-id="element-61" data-mp="20zb0qasxr5ei">
                      Without:
                    </span>
                    {row.without}
                  </span>
                </p>
                <p className="flex items-start gap-3 bg-paper-100 p-3 text-sm font-medium leading-relaxed text-ink sm:bg-transparent sm:p-0 sm:text-base" data-id="element-62" data-mp="1r26b20zvsrsy">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brass" aria-hidden="true" data-id="element-63" data-mp="fjlsvt25zi7e" />
                  <span data-id="element-64" data-mp="h2vi27qev9ys">
                    <span className="mr-1 font-semibold uppercase tracking-wide text-brass-dark sm:hidden" data-id="element-65" data-mp="h2loka65qkoc">
                      With:
                    </span>
                    {row.with}
                  </span>
                </p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}